import { Routes } from '@angular/router';
import { adminAuthGuard } from './guards/admin-auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'dashboard',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
    },
    {
        path: 'settings',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/setting/setting.component').then(m => m.SettingComponent)
    },
    {
        path: 'banners',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/banner-management/banner-list/banner-list.component').then(m => m.BannerListComponent)
    },
    {
        path: 'events',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/event-management/event-management.component').then(m => m.EventManagementComponent)
    },
    {
        path: 'docs',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/docs-management/docs-management.component').then(m => m.DocsManagementComponent)
    },
    {
        /* Users module — signup users listing page */
        path: 'users',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/users/users.component').then(m => m.UsersComponent)
    },
    {
        path: 'joined-users',
        canActivate: [adminAuthGuard],
        loadComponent: () => import('./components/joined-users/joined-users.component').then(m => m.JoinedUsersComponent)
    }
];
